<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="疯狂倍率" @back="goBack" /></span>
        </div>
        <el-form>
          <el-form-item label="体力限制">
            <el-input v-model.number="formData.init.actSpinsLimit" style="width: 200px;" placeholder="体力限制" />
          </el-form-item>

          <el-table :data="formData.init.spinsRangeBak" border stripe>
            <el-table-column prop="spins" label="体力">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.spins" placeholder="体力" />
              </template>
            </el-table-column>
            <el-table-column prop="bet" label="下注">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.bet" placeholder="下注" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-permisaction="['config:rewardCrazyBet:del']" style="margin-top: 10px" type="danger" @click="del(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button v-permisaction="['config:rewardCrazyBet:add']" style="margin-top: 10px" type="primary" @click="add()">+</el-button>

          <el-table :data="formData.confBak" border stripe style="margin-top: 10px;">
            <el-table-column prop="spins" label="体力">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.spins" placeholder="体力" />
              </template>
            </el-table-column>
            <el-table-column prop="bet" label="下注">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.bet" placeholder="下注" />
              </template>
            </el-table-column>
            <el-table-column prop="levelId" label="等级ID">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.levelId" placeholder="等级ID" />
              </template>
            </el-table-column>
            <el-table-column prop="spinsLimit" label="下注限制">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.spinsLimit" placeholder="下注限制" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-permisaction="['config:rewardCrazyBet:del']" style="margin-top: 10px" type="danger" @click="del2(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-button v-permisaction="['config:rewardCrazyBet:add']" style="margin-top: 10px" type="primary" @click="add2()">+</el-button>
          <el-button v-permisaction="['config:rewardCrazyBet:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActivtyStageRewardCfg, updateActivtyStageRewardCfg } from '@/api/config/activity-cfg'
export default {
  name: 'CrazyBet',
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      aid: 0,
      type: 0,
      ucType: 0,
      isOnline: 0,
      formData: {
        'init': {
          'actSpinsLimit': '150',
          spinsRangeBak: [
            {
              'id': '1',
              'spins': '100',
              'bet': '1'
            }
          ],
          'spinsRange': {
            '1': {
              'id': '1',
              'spins': '100',
              'bet': '1',
              'spinsLimit': '1'
            }
          }
        },
        'confBak': [
          {
            'id': '1',
            'bet': '1',
            'levelId': '1',
            'spins': '0'
          }
        ],
        'conf': {
          '1': {
            'id': '1',
            'bet': '1',
            'levelId': '1',
            'spins': '0'
          }
        }
      }

    }
  },
  created() {
    this.aid = this.$route.query.id
    this.type = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    onSubmit() {
      const formData = this.formData
      formData.init.spinsRange = {}
      formData.conf = {}
      let j = 1
      for (const i in formData.init.spinsRangeBak) {
        formData.init.spinsRangeBak[i].id = j
        formData.init.spinsRange[j] = formData.init.spinsRangeBak[i]
        j++
      }
      j = 1
      for (const i in formData.confBak) {
        formData.confBak[i].id = j
        formData.conf[j] = formData.confBak[i]
        j++
      }
      delete formData.init.spinsRangeBak
      delete formData.confBak
      const postData = { type: this.type, aid: this.aid, reward: formData }
      const data = JSON.stringify(postData)
      console.log('data', data)
      updateActivtyStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.formData = { init: { actSpinsLimit: 0, spinsRangeBak: [] }, confBak: [] }
          const data = res.data.reward
          if (data) {
            const formData = data
            formData.init.spinsRangeBak = []
            formData.confBak = []
            for (const i in data.init.spinsRange) {
              formData.init.spinsRangeBak.push(data.init.spinsRange[i])
            }
            for (const i in data.conf) {
              formData.confBak.push(data.conf[i])
            }
            this.formData = formData
            console.log('formData', this.formData)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.init.spinsRangeBak.push({
        id: 0,
        spins: 0,
        bet: 0
      })
    },
    add2() {
      this.formData.confBak.push({
        id: 0,
        bet: 0,
        levelId: 0,
        spins: 0,
        spinsLimit: 0
      })
    },
    del(i) {
      this.formData.init.spinsRangeBak = this.formData.init.spinsRangeBak.filter((item, k) => {
        return k !== i
      })
    },
    del2(i) {
      this.formData.confBak = this.formData.confBak.filter((item, k) => {
        return k !== i
      })
    }
  }
}
</script>

<style scoped>
</style>
